module.exports = __webpack_public_path__ + "static/media/skill2_neg_en.3d0a3479.txt";